"use strict";

module.exports = function () {
  this.serverSearch();
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/refresh.js
// module id = f1cp
// module chunks = 0